<template>
  <ImportUsersModal
    :handleCancel="handleCancel"
    :headerIcon="headerIcon"
    headerText="Workday Import"
    importType="workday"
    :itemType="itemType"
    :visible="true"
  >
    <template #selectionComponent>
      <WorkdayImportSelection
        :workdayId="workdayId"
      />
    </template>
  </ImportUsersModal>
</template>
<script>
import { ItemTypeConsts } from 'client/util/Constants';
import ImportUsersModal from 'client/components/ImportUsers/ImportUsersModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import WorkdayAvatarIcon from 'public/img/icons/workdayAvatar.svg?inline';
import WorkdayImportSelection from 'client/directories/Workday/WorkdayImportSelection.vue';

export default {
  name: 'WorkdayImport',

  components: {
    ImportUsersModal,
    WorkdayImportSelection,
  },

  props: {
    workdayId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      headerIcon: WorkdayAvatarIcon,
      itemType: ItemTypeConsts.workdayWorker,
    };
  },

  methods: {
    handleCancel() {
      ModalEventBus.close();
    },
  },
};
</script>
